import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listSubAgents } from '../actions/subagentActions';

export default function SubAgent() {
    const dispatch = useDispatch();

    const subAgentList = useSelector(state => state.subAgentList);
    const { subAgents, loading, error } = subAgentList

    useEffect(() => {
        if (subAgents == undefined) {
            dispatch(listSubAgents())
        }else if(subAgents.length == 0){
            dispatch(listSubAgents())
        }
    }, [dispatch, subAgents])

    return (
        <>
        {
            loading ? (
                <option value="0" key="1">Loading...</option>
            ) : (
                subAgents ? (
                    subAgents.map((countf,index) => (
                        <option key={index+1} value={countf.SubAgent_Id}>
                            {countf.SubAgent_Name}
                        </option>
                    ))
                ) : (
                    <option value="0" key="1">{error}</option>
                )
            )
        }
        </>

  )
}

